import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/avatar-info-image.png'
import _imports_1 from '../../../assets/icons/dual-message.svg'


const _withScopeId = n => (_pushScopeId("data-v-85a5a0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team__data desktop__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Member Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Revenue Generated"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Jobs Completed"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Working Days"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Role"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Customer Rating"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_3 = {
  class: "text-left",
  "data-label": 'Member Name'
}
const _hoisted_4 = { class: "member__name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "member_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = {
  class: "text-left",
  "data-label": 'Revenue Generated'
}
const _hoisted_7 = {
  class: "text-left",
  "data-label": 'Jobs Completed'
}
const _hoisted_8 = {
  class: "text-left",
  "data-label": 'Working Days'
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-left",
  "data-label": 'Role'
}, "Contractor", -1))
const _hoisted_10 = {
  class: "text-left",
  "data-label": 'Customer Rating'
}
const _hoisted_11 = { class: "view-rating-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-center",
  "data-label": 'Action'
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "tw-cursor-not-allowed"
  })
], -1))
const _hoisted_13 = {
  key: 1,
  class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-p-4 tw-box-border tw-items-center tw-justify-center tw-gap-4"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import AnalyticsWidgetLayout from "@/core/components/slots/AnalyticsWidgetLayout.vue";
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { ANALYTICS_STORE } from "@/store/modules/analytics";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamPerformanceCard',
  setup(__props) {

const store = useStore();

const filterItems = ref([
  { range: "Today" },
  { range: "Last 7 Days" },
  { range: "Last 4 Weeks" },
  { range: "Last 3 Months" },
  { range: "Last 12 Months" },
  { range: "Month To date" },
  { range: "Quarter to date" },
  { range: "Year to date" },
  { range: "All time" },
]);

const teamPerformance = computed(
  () => store.getters[`${ANALYTICS_STORE}/getTeamPerformance`]
);

onMounted(() => {
  console.log(teamPerformance.value, "teamPerformance value in mounted");
});

return (_ctx: any,_cache: any) => {
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(AnalyticsWidgetLayout, {
    class: "team__widget",
    title: "Team Performance",
    hideToolTip: true,
    headerIcon: "teamPerformance",
    borderBottom: true,
    isHeaderAction: true
  }, {
    "header-action": _withCtx(() => []),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (teamPerformance.value && teamPerformance.value.length)
          ? (_openBlock(), _createBlock(_component_v_table, {
              key: 0,
              "fixed-header": "",
              height: "250px",
              "data-label": 'Member Name'
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamPerformance.value, (member, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createElementVNode("p", null, _toDisplayString(member?.name), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_6, _toDisplayString(member?.revenue), 1),
                      _createElementVNode("td", _hoisted_7, _toDisplayString(member?.jobCompletecount), 1),
                      _createElementVNode("td", _hoisted_8, _toDisplayString(member?.daysWorked) + " Days ", 1),
                      _hoisted_9,
                      _createElementVNode("td", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_rating, {
                            "active-color": "orange",
                            color: "rgba(12, 15, 74, 0.26)",
                            "empty-icon": "mdi-star",
                            readonly: "",
                            "model-value": member?.avgRating
                          }, null, 8, ["model-value"]),
                          _createElementVNode("p", null, _toDisplayString(member?.avgRating) + " out of 5", 1)
                        ])
                      ]),
                      _hoisted_12
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("img", {
                src: require('@/assets/icons/team-performance-empty-screen.svg'),
                alt: ""
              }, null, 8, _hoisted_14),
              _createVNode(Text, {
                variant: "p",
                textWeight: "600",
                textColor: "rgba(12, 15, 74, 0.5)"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Your Team Performance data will"),
                  _hoisted_15,
                  _createTextVNode(" appear here")
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})